const formatter = (value: string) => {
    return value === 'CONTAINER_LOADED' ?
        "Container / Chassis (Loaded)"
        :
        value === 'CONTAINER_EMPTY' ?
            "Container / Chassis (Empty)"
            :
            value === 'CHASSIS_ONLY' ?
                "Chassis Only"
                :
                value === 'TRUCK_CONTAINER_LOADED' ?
                    "Truck + Container / Chassis (Loaded)"
                    :
                    value === 'TRUCK_CONTAINER_EMPTY' ?
                        "Truck + Container / Chassis (Empty)"
                        :
                        value === 'TRUCK_TRAILER_LOADED' ?
                            "Truck + Trailer (Loaded)"
                            :
                            value === 'TRUCK_TRAILER_EMPTY' ?
                                "Truck + Trailer (Empty)"
                                :
                                value === 'TRUCK_ONLY' ?
                                    "Truck Only"
                                    :
                                    value === 'TRAILER_LOADED' ?
                                        "Trailer (Loaded)"
                                        :
                                        value === 'TRAILER_EMPTY' ?
                                            "Trailer (Empty)"
                                            :
                                            value === 'REEFER_LOADED_PLUGIN' ?
                                                "Refrigerated (Loaded) (Plug In"
                                                :
                                                value === 'REEFER_LOADED_NO_PLUGIN' ?
                                                    "Reefer (Loaded) (No Plug In)"
                                                    :
                                                    value === 'TRUCK_REEFER_LOADED_PLUGIN' ?
                                                        "Truck + Reefer (Loaded) (Plug In)"
                                                        :
                                                        value === 'TRUCK_REEFER_LOADED_NO_PLUGIN' ?
                                                            "Truck + Reefer (Loaded) (No Plug In)"
                                                            :
                                                            value;
}

const formatFrequency: (frequency: string, durationType: string) => string = (frequency, durationType) => {
    if (frequency === 'RECURRING') {
        if (durationType === 'WEEKLY') {
            return 'Recurring - Weekly';
        } else if (durationType === 'MONTHLY') {
            return 'Recurring - Monthly';
        } else if (durationType === 'DAILY') {
            return 'Recurring - Daily'
        } else {
            return 'Recurring';
        }
    } else if (frequency === 'ONE_TIME') {
        return 'One-Time';
    } else {
        return 'N/A';
    }
};

const formatLink: (baseUrl: string, value: any, queryParam?: string | undefined) => string = (baseUrl, value, queryParam) => {
    if (queryParam) {
        const queryParams = new URLSearchParams();
        queryParams.append(queryParam, value);
        if (baseUrl.endsWith('?') || baseUrl.endsWith('&')) {
            baseUrl = baseUrl + queryParams.toString();
        } else {
            baseUrl = `${baseUrl}?${queryParams}`;
        }
    } else {
        baseUrl = baseUrl.endsWith('/') ? baseUrl + value : `${baseUrl}/${value}`;
    }
    return baseUrl;
};

export {
    formatter,
    formatFrequency,
    formatLink
};
